import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = 'Escape Ed';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Bushy Evergreen] </Text><a target="_blank" rel="noopener noreferrer" href="http://cs.wellesley.edu/~cs249/Resources/ed_is_the_standard_text_editor.html">Ed Is The Standard Text Editor</a></Flex>),
];
  const assignment = `Hi, I'm Bushy Evergreen. Welcome to Elf U!
I'm glad you're here. I'm the target of a terrible trick.
Pepper Minstix is at it again, sticking me in a text editor.
Pepper is forcing me to learn ed.
Even the hint is ugly. Why can't I just use Gedit?
Please help me just quit the grinchy thing.`;
  const data = useStaticQuery(graphql`
    query {
      cranEd: file(relativePath: { eq: "cranEd.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      edScreen: file(relativePath: { eq: "edScreen.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)
  const extra = (
    <>
    <Img fluid={data.cranEd.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: Train Station</Text>
    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      assignment={assignment}
      extra={extra}
    >
      <Text mb={2}>All we have to do is enter command <code>q</code></Text>
      <Img fluid={data.edScreen.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '65vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
  </Entry>
  )

};
